import PropTypes from 'prop-types';

import { Button } from '#/modules/commonComponents/button';

const ScanTriggerButton = ({
  labels,
  onClick,
  disabled = false,
  size = 'sm',
}) => (
  <Button
    type="button"
    size={size}
    onClick={onClick}
    disabled={disabled}
  >
    {labels?.trigger}
  </Button>
);

ScanTriggerButton.propTypes = {
  labels: PropTypes.shape({
    trigger: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
};

export default ScanTriggerButton;
